import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useModalStore from './store/use-modal-store';

export default function ModalContainer() {
  const { isOpen, content, closeModal } = useModalStore();
  console.log('render', 'ModalContainer');
  return (
    <Dialog open={isOpen} onClose={() => closeModal(null)}>
      <IconButton
        onClick={() => closeModal(null)}
        sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}
      >
        <CloseIcon sx={{ fontSize: 28 }} />
      </IconButton>
      <DialogContent sx={{ paddingTop: 4 }}>{content}</DialogContent>
    </Dialog>
  );
}
